<template>
  <div>
    <el-input :value="displayValue"
              :type="type"
              :placeholder="placeholder"
              :disabled="disabled"
              :readonly="readonly"
              clearable
              @input="handleInput"
              @change="handleInputChange"
              @blur="handleBlur"
              @focus="handleFocus"
              ref="custom_input"
              class="">
    </el-input>
  </div>
</template>

 <script>
/**
 * @desc 输入框组件（限制输入负数，限制小数位的输入框；控制输入整数；限制输入长度的）
 * @param value {String} 绑定值
 * @param precision { Number }  设置精准值（保留多少位小数）
 * @param type { String } 类型
 * @param readonly { boolean } 原生属性，是否只读
 * @param disabled { boolean } 禁用
 * @param placeholder { String } 原生属性，是否只读
 * @param maxlength { Number } 最大长度
 */
export default {
  name: 'CustomInput',
  props: {
    //输入框的值
    value: {
      type: [String, Number],
      default: ''
    },
    //输入框的类型
    type: {
      type: String,
      default: 'text'
    },
    //默认字符
    placeholder: {
      type: String,
      default: '请输入'
    },
    //最大长度
    maxlength: {
      type: [Number],
      default: 10
    },
    //数值精度 0 整数
    precision: {
      type: Number,
      validator(val) {
        return val >= 0 && val === parseInt(val, 10);
      }
    },
    // 是否禁用输入框
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否输入框仅读
    readonly: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      currentValue: '', // 当前的值
      userInput: null, // 上次的值
    }
  },
  watch: {
    value: {
      // immediate: true,
      handler(value) {
        if (this.validatenull(value)) {
          this.currentValue = value;
          this.userInput = null;
          this.$emit('input', value);
          return
        }
        let newVal = Number(value);
        if (newVal !== undefined) {
          if (isNaN(newVal)) return
          if (this.precision !== undefined) {
            newVal = newVal.toFixed(this.precision);
          }
        }
        this.currentValue = newVal;
        this.userInput = null;
        this.$emit('input', newVal);
      }
    }
  },
  computed: {
    displayValue() {
      if (this.userInput !== null) {
        return this.userInput;
      }
      let currentValue = this.currentValue == '' ? this.value : this.currentValue;
      if (typeof currentValue === 'number' && this.precision !== undefined) {
        currentValue = currentValue.toFixed(this.precision);
      }
      return currentValue;
    }
  },
  mounted() { },
  methods: {
    //输入事件
    handleInput(value) {
      this.userInput = this.limitNumTool(value)
      this.$emit('handleInput', this.userInput)
    },
    //输入改变，并失去焦点
    handleInputChange(value) {
      const newVal = value === '' ? undefined : Number(value);
      if (!isNaN(newVal) || value === '') {
        this.setCurrentValue(newVal);
        this.$emit('handleInputChange', this.userInput)
      }
      this.userInput = null;
    },
    // 用来设置 中间所显示的数字的值
    setCurrentValue(newVal) {
      const oldVal = this.currentValue;
      if (typeof newVal === 'number' && this.precision !== undefined) {
        newVal = this.toPrecision(newVal, this.precision);
      }
      // 解决负数问题
      if (newVal && 0 > newVal) {
        newVal = Math.abs(newVal)
      }
      if (oldVal === newVal) return;
      this.userInput = null;
      this.$emit('input', newVal);
      this.$emit('change', newVal, oldVal);
      this.currentValue = newVal;
    },

    //按精度转换数值【截取为传入的位数】
    toPrecision(num, precision) {
      return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
    },
    //失去焦点
    handleBlur(event) {
      this.$emit('blur', event);
    },
    handleFocus(event) {
      this.$emit('focus', event);
    },
    // 限制数字的位数
    limitNumTool(value) {
      let newValue = value.split('.');
      let result = {
        integer: '',
        decimals: '',
      };
      // 整数位
      if (newValue[0].length) {
        result.integer = newValue[0].slice(0, this.maxlength - this.precision)
      }
      // 小数位
      if (newValue[1] && newValue[1].length) {
        result.decimals = newValue[1].slice(0, this.precision);
      }
      let str = value.indexOf('.') > 0 ? (result.integer + '.' + result.decimals) : result.integer
      return str
    }
  }
}
 </script>

 <style scoped lang='scss'>
</style>
